import { Injectable } from '@angular/core';
import {BehaviorSubject, throwError} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {catchError, map, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class DbnomicsService {

  private _providers = new BehaviorSubject<{}>([]);
  private _datasets = new BehaviorSubject<{}>([]);
  private _indicators = new BehaviorSubject<{}>([]);
  private _countries = new BehaviorSubject<{}>([]);

  constructor(private http: HttpClient) {}

  getProviders(){return this._providers.asObservable();}
  getDatasets(){return this._datasets.asObservable();}
  getIndicators(){return this._indicators.asObservable();}
  getCountries(){return this._countries.asObservable();}


  readProviders(){
    this.http.get('http://api.db.nomics.world/v22/providers').pipe( map(data => {
      let res = {}
      for ( let prov of data['providers'].docs){
        res[prov['name']] = prov['code'];
      }
      return res;
    }), tap( data => {
      this._providers.next(data);
    }));
  }

  readDatasets(provider = 'WB'){
    return this.http.get('https://api.db.nomics.world/v22/datasets/'+provider).pipe( map(data => {
      let res = {}
      for ( let prov of data['datasets'].docs){
        res[prov['name']] = {code: prov['code'], desc: prov['description']};
      }
      return res;
    }), tap( datasets => {
      this._datasets.next(datasets);
    }) );
  }

  readIndicators(provider='WB', dataset='DB'){
    return this.http.get('https://api.db.nomics.world/v22/series/'+provider+'/'+dataset+'?observations=1').pipe( map( data => {
      let indicators = this.swap(data['dataset'].dimensions_values_labels.indicator);
      let countries = this.swap(data['dataset'].dimensions_values_labels.country);
      return {indicators: indicators, countries: countries};
    }), tap( res =>{
      this._indicators.next(res['indicators']);
      this._countries.next(res['countries']);
    }));
  }

  readParams(provider = 'WB', dataset ='DB') {
    let order = [];
    let query = [];
    let params = [];
    return this.http.get('https://api.db.nomics.world/v22/series/'+provider+'/'+dataset+'?observations=1').pipe( map( data => {

      order = data['dataset']['dimensions_codes_order'];
      for( let p of order){
        let r = data['dataset']['dimensions_values_labels'][p];
        query[p] = this.getKeys(r)[0];
        params.push({title: p, list: this.getValues(r), abrev: this.swap(r) });
      }
      console.log(query);
      this.getQuery(order, query);

      return {params: params, query: query, order: order};
    }));
  }


  readSeries(provider, database, query) {
    return this.http.get('https://api.db.nomics.world/v22/series/'+provider+'/'+database+'/'+query+'?observations=1').pipe(  catchError( err => { console.log(err); return throwError(
      'Indicator not found for country.');}), map( data =>{
      let dataa = this.parseRespone(data);
      let labels = data['series']['docs'][0]['period'];
      return {data: dataa, labels: labels};
    }));
  }

  readSeries2(provider, database, query, query2) {
    let root = provider+'/'+database+'/';
    return this.http.get('https://api.db.nomics.world/v22/series?observations=1&series_ids='+root+query +','+root+query2).pipe(  catchError( err => { console.log(err); return throwError(
      'Indicator not found for country.');}), map( data =>{
      let dataa = this.parseRespone(data);
      let labels = data['series']['docs'][0]['period'];
      console.log({data: dataa, labels: labels}, 'https://api.db.nomics.world/v22/series?observations=1&series_ids='+root+query +','+root+query2);
      return {data: dataa, labels: labels};
    }));
  }




  search(term){
    return this.http.get('https://api.db.nomics.world/v22/search?limit=10&offset=0&q=' + term)
      .pipe(
        map(res => {
          let data = [];
          for( let r of res['results']['docs'] ){
            data.push({
              code: r['code'],
              description: r['description'],
              name:r['name'],
              provider: r['provider_code'],
              provider_name: r['provider_name'],
              update: r['updated_at'] });
          }
          return data;})
      );
  }

  searchDb(prov, db, term){
    return this.http.get('https://api.db.nomics.world/v22/series/'+prov+'/'+db+'?limit=10&offset=0&q='+term+'&observations=1')
      .pipe( map( res =>{
        let datas = [];
        for(let r of res['series']['docs']){
          let data = {data: [{data: r['value'], label:r['series_name']}], labels:r['period'], link: r['series_code']}
          datas.push(data);
        }
        return datas;
      }));
  }




  // ----------------- helpers

  public swap(json){
    let ret = {};
    for(let key in json){
      ret[json[key]] = key;
    }
    return ret;
  }

  getKeys(json){
    return Object.keys(json);
  }

  public parseRespone(dat){
    let res = []
    for ( let s of dat.series.docs ){
      res.push( {data: s.value, label: s.series_name} );
    }
    return res;
  }


  getValues(json) {
    let res = [];
    for ( let k in json){
      res.push(json[k]);
    }
    return res;
  }

  public getQuery(order, query){
    let sep = '.';
    if( query['provider'] === 'WB' ){sep = '-';}
    return order.slice(0, order.length -1).map(p => query[p]).join('.') + sep + query[order.slice(-1)[0]];
  }


}
